import { Alert } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import warningAnimation from "./assets/warningAnimation.json";

interface ComponentProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onRequestClose: () => void;
}

export const CurrencyFieldAlert = ({
  isOpen,
  onCancel,
  onConfirm,
  onRequestClose,
}: ComponentProps) => {
  const { t } = useTranslations();

  return (
    <Alert
      isOpen={isOpen}
      img={
        <Lottie
          options={{
            animationData: warningAnimation,
            rendererSettings: {
              preserveAspectRatio: "xMidYMid slice",
            },
          }}
          width={80}
          height={80}
        />
      }
      title={t({
        id: "invoices.currency-alert-title",
        defaultMessage: "Currency Alert",
      })}
      content={t({
        id: "invoices.currency-alert-content",
        defaultMessage:
          "The selected currency doesn't match the workspace currency. Prices must be updated manually.",
      })}
      buttons={[
        {
          text: t({
            id: "common.cancel",
            defaultMessage: "Cancel",
          }),
          role: "close",
          onClick: onCancel,
        },
        {
          text: t({
            id: "invoices.currency-accept-button",
            defaultMessage: "Change Currency",
          }),
          color: "tertiary",
          onClick: onConfirm,
        },
      ]}
      onRequestClose={onRequestClose}
    />
  );
};
